import React from 'react'

export const POPULAR_CHOICE_ICON_SRC = '/media/room-types/popular-choice.svg'

export type PopularChoiceBannerProps = {
  body: string
  title: string
}

/**
 * Figma Message banner (#1926:9119) used on room-type cards and room detail.
 */
export function PopularChoiceBanner({ body, title }: PopularChoiceBannerProps) {
  return (
    <aside
      aria-label={title}
      className="flex items-center gap-2 rounded-[10px] border-[1.5px] border-black/10 bg-[#002140] p-4"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <p className="font-display text-base font-medium leading-5 tracking-[-0.04em] text-[#8DC8FF]">
          {title}
        </p>
        <p className="font-outfit text-sm leading-4 text-white/95">{body}</p>
      </div>
      <span
        aria-hidden
        className="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#003C73]"
      >
        <img
          alt=""
          aria-hidden
          className="size-6"
          height={24}
          src={POPULAR_CHOICE_ICON_SRC}
          width={24}
        />
      </span>
    </aside>
  )
}
